(function () {
    'use strict';

    /*
     * 92_オプション画像から出力したCSV
     */
    var OPTION_IMAGES_CSV_URL =
        'https://cdn.shopify.com/s/files/1/0824/3678/4381/files/option-images.csv?v=1790472590';

    var optionImages = {};

    /*
    * 商品ごとの画像オプション設定。
    *
    * 商品ページのhandleから対象商品を判定し、
    * 92_オプション画像の「商品」と紐付ける。
    *
    * 画像カードを使用する商品はここへ追加する。
    */
    var PRODUCT_CONFIG = {
        'アクキー': {
            imageProduct: 'アクキー',
            handle: 'acrylic-keyholder'
        },

        '反射板キーホルダー': {
            imageProduct: '反射板キーホルダー',
            handle: 'reflective-keyholder'
        },

        'アクスタ': {
            imageProduct: 'アクスタ',
            handle: 'acrylic-stand'
        },

        'Tシャツ': {
            imageProduct: 'Tシャツ',
            handle: 't-shirt'
        },

        'サコッシュ': {
            imageProduct: 'サコッシュ',
            handle: 'sacoche'
        },

        'トートバッグ': {
            imageProduct: 'トートバッグ',
            handle: 'tote-bag'
        },

        'ステッカー': {
            imageProduct: 'ステッカー',
            handle: 'sticker'
        },

        'ホログラム缶バッジ': {
            imageProduct: 'ホログラム缶バッジ',
            handle: 'hologram-badge'
        },

        'マグネット': {
            imageProduct: 'マグネット',
            handle: 'magnet'
        }
    };


    /**
     * CSVの1行を配列に変換する。
     * ダブルクォート・カンマ入りにも対応。
     */
    function parseCsvLine(line) {
        var result = [];
        var current = '';
        var inQuotes = false;

        for (var i = 0; i < line.length; i++) {
            var char = line[i];

            if (char === '"') {
                if (
                    inQuotes &&
                    line[i + 1] === '"'
                ) {
                    current += '"';
                    i++;
                } else {
                    inQuotes = !inQuotes;
                }
            } else if (
                char === ',' &&
                !inQuotes
            ) {
                result.push(current);
                current = '';
            } else {
                current += char;
            }
        }

        result.push(current);

        return result;
    }


    /**
     * option-images.csvを読み込む。
     *
     * CSV：
     * 商品 / 項目 / 選択肢 / 表示名 / 画像ファイル
     */
    function loadOptionImages() {
        return fetch(OPTION_IMAGES_CSV_URL)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error(
                        'option-images.csv HTTP ' +
                        response.status
                    );
                }

                return response.text();
            })
            .then(function (csvText) {
                var lines = csvText
                    .replace(/^\uFEFF/, '')
                    .split(/\r?\n/)
                    .filter(function (line) {
                        return line.trim() !== '';
                    });

                if (lines.length < 2) {
                    return;
                }

                var headers = parseCsvLine(lines[0]);

                var productIndex =
                    headers.indexOf('商品');

                var fieldIndex =
                    headers.indexOf('項目');

                var optionIndex =
                    headers.indexOf('選択肢');

                var labelIndex =
                    headers.indexOf('表示名');

                var imageIndex =
                    headers.indexOf('画像ファイル');

                if (
                    productIndex === -1 ||
                    fieldIndex === -1 ||
                    optionIndex === -1 ||
                    imageIndex === -1
                ) {
                    throw new Error(
                        'option-images.csvの見出しが不足しています。'
                    );
                }

                for (var i = 1; i < lines.length; i++) {
                    var row = parseCsvLine(lines[i]);

                    var product =
                        (row[productIndex] || '').trim();

                    var field =
                        (row[fieldIndex] || '').trim();

                    var option =
                        (row[optionIndex] || '').trim();

                    var label =
                        labelIndex !== -1
                            ? (row[labelIndex] || '').trim()
                            : '';

                    var imageFile =
                        (row[imageIndex] || '').trim();

                    if (
                        !product ||
                        !field ||
                        !option
                    ) {
                        continue;
                    }

                    if (!optionImages[product]) {
                        optionImages[product] = {};
                    }

                    if (!optionImages[product][field]) {
                        optionImages[product][field] = {};
                    }

                    optionImages[product][field][option] = {
                        label: label || option,
                        imageFile: imageFile
                    };
                }

                console.log(
                    '[Charamoa Option Images] CSV loaded',
                    optionImages
                );
            });
    }


    /**
     * name属性から項目名を取得する。
     *
     * properties[カラー]
     * ↓
     * カラー
     */
    function getFieldName(input) {
        if (!input || !input.name) {
            return '';
        }

        var match =
            input.name.match(
                /properties\[([^\]]+)\]/
            );

        if (match && match[1]) {
            return match[1];
        }

        return input.name;
    }


    /*
 * 現在の商品ページを判定する。
 *
 * URLのproduct handleとPRODUCT_CONFIGを照合し、
 * 92_オプション画像で使用する商品名を返す。
 */
    function getCurrentProduct() {
        var path = window.location.pathname;

        var productNames =
            Object.keys(PRODUCT_CONFIG);

        for (
            var i = 0;
            i < productNames.length;
            i++
        ) {
            var productName =
                productNames[i];

            var config =
                PRODUCT_CONFIG[productName];

            if (
                path.indexOf(
                    '/products/' + config.handle
                ) !== -1
            ) {
                return config.imageProduct;
            }
        }

        return '';
    }


    /**
     * 商品 × 項目 × 選択肢から
     * 92の画像情報を取得する。
     */
    function getImageData(
        product,
        field,
        optionValue
    ) {
        if (
            !optionImages[product] ||
            !optionImages[product][field]
        ) {
            return null;
        }

        return (
            optionImages[product][field][optionValue] ||
            null
        );
    }


    /**
     * 画像URLを取得する。
     */
    function getImageUrl(imageData) {
        if (
            !imageData ||
            !imageData.imageFile ||
            !window.charamoaOptionImageAssets
        ) {
            return '';
        }

        return (
            window.charamoaOptionImageAssets[
            imageData.imageFile
            ] || ''
        );
    }


    /**
     * カード本体を作る。
     */
    function createCard(
        product,
        field,
        optionValue,
        selected
    ) {
        var imageData =
            getImageData(
                product,
                field,
                optionValue
            );

        var card =
            document.createElement('button');

        card.type = 'button';

        card.className =
            'charamoa-option-image-card';

        card.setAttribute(
            'data-option-value',
            optionValue
        );

        /*
         * 画像がある場合
         */
        var imageUrl =
            getImageUrl(imageData);

        if (imageUrl) {
            card.classList.add(
                'has-image'
            );

            var image =
                document.createElement('img');

            image.src = imageUrl;

            image.alt =
                imageData && imageData.label
                    ? imageData.label
                    : optionValue;

            card.appendChild(image);
        } else {
            /*
             * 画像なしカード。
             * CSSで画像カードと区別できるようにする。
             */
            card.classList.add(
                'is-text-only'
            );
        }

        /*
         * 表示名
         */
        var label =
            document.createElement('span');

        label.className =
            'charamoa-option-image-label';

        label.textContent =
            imageData && imageData.label
                ? imageData.label
                : optionValue;

        card.appendChild(label);

        if (selected) {
            card.classList.add(
                'is-selected'
            );
        }

        return card;
    }


    /**
     * パネル内の選択状態を更新する。
     */
    function updateSelectedCard(
        panel,
        value
    ) {
        var cards =
            panel.querySelectorAll(
                '.charamoa-option-image-card'
            );

        cards.forEach(function (card) {
            if (
                card.getAttribute(
                    'data-option-value'
                ) === value
            ) {
                card.classList.add(
                    'is-selected'
                );
            } else {
                card.classList.remove(
                    'is-selected'
                );
            }
        });
    }

    /**
     * 価格条件を変更したとき、
     * 前回クリックした価格表の選択結果を解除する。
     *
     * 価格計算やDPOには触れず、
     * 表示だけをリセットする。
     */
    function resetSelectedPriceDisplay() {
        /*
         * 価格表セルの選択枠を解除
         */
        document
            .querySelectorAll(
                '.charamoa-price-cell.is-selected'
            )
            .forEach(function (cell) {
                cell.classList.remove(
                    'is-selected'
                );
            });

        /*
         * 前回の選択結果を非表示
         */
        var selectedPrice =
            document.getElementById(
                'charamoa-selected-price'
            );

        if (selectedPrice) {
            selectedPrice.hidden = true;
        }

        var totalPriceWrap =
            document.getElementById(
                'charamoa-total-price-wrap'
            );

        if (totalPriceWrap) {
            totalPriceWrap.hidden = true;
        }
    }

    /**
     * 価格表が未選択の場合、
     * カート投入を止めて案内を表示する。
     */
    function initPriceTableValidation() {
        document.addEventListener(
            'click',
            function (event) {
                var addToCartButton =
                    event.target.closest(
                        '.dpo_add2cart'
                    );

                if (!addToCartButton) {
                    return;
                }

                /*
                 * 現在の条件で価格表セルが
                 * 選択されているか確認。
                 */
                var selectedCell =
                    document.querySelector(
                        '.charamoa-price-cell.is-selected'
                    );

                if (selectedCell) {
                    /*
                     * 選択済みなら何もしない。
                     * DPO本来のaddToCartへ進ませる。
                     */
                    return;
                }

                /*
                 * DPOのonclickより先に止める。
                 */
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                /*
                 * 既存エラーがなければ作成。
                 */
                var error =
                    document.getElementById(
                        'charamoa-price-table-error'
                    );

                if (!error) {
                    error =
                        document.createElement('p');

                    error.id =
                        'charamoa-price-table-error';

                    error.className =
                        'charamoa-price-table-error';

                    error.textContent =
                        '価格が選択されていません。下の価格表から、ご希望の数量と営業日の価格をクリックしてください。';

                    var tableWrap =
                        document.getElementById(
                            'charamoa-price-table-wrap'
                        );

                    if (tableWrap) {
                        tableWrap.insertAdjacentElement(
                            'beforebegin',
                            error
                        );
                    }
                }

                /*
                 * 価格表までスクロール。
                 */
                var priceTableSection =
                    document.querySelector(
                        '.charamoa-price-table-section'
                    );

                if (priceTableSection) {
                    var headerOffset = 140;

                    var elementPosition =
                        priceTableSection.getBoundingClientRect().top;

                    var offsetPosition =
                        elementPosition +
                        window.pageYOffset -
                        headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            },
            true
        );
    }

    /**
     * selectをカード化する。
     */
    function createSelectPanel(
        select,
        product
    ) {
        if (
            select.getAttribute(
                'data-charamoa-card-ready'
            ) === 'true'
        ) {
            return;
        }

        var field =
            getFieldName(select);

        if (!field) {
            return;
        }

        var panel =
            document.createElement('div');

        panel.className =
            'charamoa-option-image-panel';

        panel.setAttribute(
            'data-charamoa-field',
            field
        );

        Array.prototype.forEach.call(
            select.options,
            function (option) {
                var optionValue =
                    option.value;

                /*
                 * 空のplaceholder optionは
                 * カードにしない。
                 */
                if (!optionValue) {
                    return;
                }

                var card =
                    createCard(
                        product,
                        field,
                        optionValue,
                        optionValue === select.value
                    );

                card.addEventListener(
                    'click',
                    function () {
                        resetSelectedPriceDisplay();

                        select.value =
                            optionValue;

                        select.dispatchEvent(
                            new Event(
                                'change',
                                {
                                    bubbles: true
                                }
                            )
                        );

                        updateSelectedCard(
                            panel,
                            optionValue
                        );
                    }
                );

                panel.appendChild(card);
            }
        );

        /*
         * カードが作られなかった場合は
         * 元selectをそのまま残す。
         */
        if (!panel.children.length) {
            return;
        }

        select.insertAdjacentElement(
            'afterend',
            panel
        );

        select.classList.add(
            'charamoa-option-source-select'
        );

        select.setAttribute(
            'data-charamoa-card-ready',
            'true'
        );

        /*
         * 外部処理でselect値が変わった場合にも
         * カード表示を同期する。
         */
        select.addEventListener(
            'change',
            function () {
                updateSelectedCard(
                    panel,
                    select.value
                );
            }
        );

        console.log(
            '[Charamoa Option Images] select panel created:',
            field
        );
    }


    /**
   * radioグループをカード化する。
   */
    function createRadioPanel(
        radios,
        product
    ) {
        if (!radios.length) {
            return;
        }

        var firstRadio =
            radios[0];

        if (
            firstRadio.getAttribute(
                'data-charamoa-card-ready'
            ) === 'true'
        ) {
            return;
        }

        var field =
            getFieldName(firstRadio);

        if (!field) {
            return;
        }

        var panel =
            document.createElement('div');

        panel.className =
            'charamoa-option-image-panel';

        panel.setAttribute(
            'data-charamoa-field',
            field
        );

        radios.forEach(function (radio) {
            var optionValue =
                radio.value;

            if (!optionValue) {
                return;
            }

            /*
             * 通常はradioのvalueを表示名として使用。
             */
            var cardLabel =
                optionValue;

            /*
             * 入稿方法だけはcustom-weight.jsが
             * data-additional-priceに料金を保持しているため、
             * カードにも料金を表示する。
             */
            if (field === '入稿方法') {
                var additionalPrice =
                    Number(
                        radio.getAttribute(
                            'data-additional-price'
                        )
                    ) || 0;

                if (additionalPrice > 0) {
                    cardLabel =
                        optionValue +
                        ' +' +
                        additionalPrice.toLocaleString(
                            'ja-JP'
                        ) +
                        '円';
                } else {
                    cardLabel =
                        optionValue +
                        ' 追加料金なし';
                }
            }

            var card =
                createCard(
                    product,
                    field,
                    cardLabel,
                    radio.checked
                );
            /*
             * 入稿方法は
             * 「サービス名」と「料金」を分けて表示する。
             */
            if (field === '入稿方法') {
                var labelElement =
                    card.querySelector(
                        '.charamoa-option-image-label'
                    );

                if (labelElement) {
                    labelElement.textContent = '';

                    var nameElement =
                        document.createElement('strong');

                    nameElement.className =
                        'charamoa-design-service-name';

                    nameElement.textContent =
                        optionValue;

                    var priceElement =
                        document.createElement('span');

                    priceElement.className =
                        'charamoa-design-service-price';

                    priceElement.textContent =
                        additionalPrice > 0
                            ? '+' +
                            additionalPrice.toLocaleString(
                                'ja-JP'
                            ) +
                            '円'
                            : '追加料金なし';

                    labelElement.appendChild(
                        nameElement
                    );

                    labelElement.appendChild(
                        priceElement
                    );
                }
            }

            /*
             * createCardには表示用の文字列を渡したので、
             * 実際のradioのvalueは別途保持する。
             */
            card.setAttribute(
                'data-option-value',
                optionValue
            );

            card.addEventListener(
                'click',
                function () {
                    resetSelectedPriceDisplay();

                    radio.checked = true;

                    radio.dispatchEvent(
                        new Event(
                            'change',
                            {
                                bubbles: true
                            }
                        )
                    );

                    updateSelectedCard(
                        panel,
                        optionValue
                    );
                }
            );

            radio.addEventListener(
                'change',
                function () {
                    if (radio.checked) {
                        updateSelectedCard(
                            panel,
                            radio.value
                        );
                    }
                }
            );

            panel.appendChild(card);

            radio.setAttribute(
                'data-charamoa-card-ready',
                'true'
            );
        });

        if (!panel.children.length) {
            return;
        }

        /*
         * 入稿方法はcustom-weight.jsで
         * .design-service-option として生成されている。
         */
        var radioContainer = null;

        if (field === '入稿方法') {
            radioContainer =
                firstRadio.closest(
                    '.design-service-option'
                );
        }

        /*
         * その他のradio用フォールバック。
         */
        if (!radioContainer) {
            radioContainer =
                firstRadio.closest(
                    '.option, .field, .form-group, div'
                );
        }

        if (!radioContainer) {
            radioContainer =
                firstRadio.parentElement;
        }

        if (!radioContainer) {
            return;
        }

        /*
         * 入稿方法の場合：
         *
         * 元UIの直前にカードを置く。
         * その後、元UI一式を非表示にする。
         */
        if (field === '入稿方法') {
            /*
             * 入稿方法の見出し・ガイドリンク
             */
            var guide =
                document.createElement('div');

            guide.className =
                'charamoa-design-service-guide';

            guide.innerHTML =
                '<div class="charamoa-design-service-heading">入稿方法</div>' +
                '<div class="charamoa-design-service-help">' +
                '入稿データの違いについては' +
                '<a href="/pages/data-guide#data-type">' +
                'データ作成ガイド' +
                '</a>' +
                'をご確認ください。' +
                '</div>';

            radioContainer.insertAdjacentElement(
                'beforebegin',
                guide
            );

            guide.insertAdjacentElement(
                'afterend',
                panel
            );

            radioContainer.classList.add(
                'charamoa-option-source-radio-container'
            );
        } else {
            radioContainer.insertAdjacentElement(
                'afterend',
                panel
            );

            radios.forEach(function (radio) {
                radio.classList.add(
                    'charamoa-option-source-radio'
                );
            });
        }

        console.log(
            '[Charamoa Option Images] radio panel created:',
            field
        );
    }


    /**
     * #props内のselectをすべてカード化する。
     */
    function initSelectPanels(
        props,
        product
    ) {
        var selects =
            props.querySelectorAll('select');

        selects.forEach(function (select) {
            createSelectPanel(
                select,
                product
            );
        });
    }


    /**
     * #props内のradioをname単位でまとめて
     * カード化する。
     */
    function initRadioPanels(
        props,
        product
    ) {
        var radioInputs =
            props.querySelectorAll(
                'input[type="radio"]'
            );

        var radioGroups = {};

        radioInputs.forEach(
            function (radio) {
                if (!radio.name) {
                    return;
                }

                if (!radioGroups[radio.name]) {
                    radioGroups[radio.name] = [];
                }

                radioGroups[radio.name].push(
                    radio
                );
            }
        );

        Object.keys(
            radioGroups
        ).forEach(function (name) {
            createRadioPanel(
                radioGroups[name],
                product
            );
        });
    }


    /**
     * STEP1の入力UIをカード化する。
     */
    function initCharamoaOptionImages() {
        var props =
            document.querySelector(
                '#charamoa-dpo-options-area #props'
            );

        if (!props) {
            return false;
        }

        var product =
            getCurrentProduct();

        /*
         * 商品がPRODUCT_CONFIGに未登録でも
         * STEP1の選択肢はカード化する。
         *
         * PRODUCT_CONFIGに登録されている商品は
         * option-images.csvの画像を使用し、
         * 未登録の商品はテキストカードとして表示する。
         */
        initSelectPanels(
            props,
            product
        );

        initRadioPanels(
            props,
            product
        );

        return true;
    }


    /**
 * DPOの入力UIが生成されるのを待ち、
 * #props内だけを監視する。
 *
 * document.body全体は監視しない。
 */
    function waitForDpoOptions() {
        var props =
            document.querySelector(
                '#charamoa-dpo-options-area #props'
            );

        /*
         * #propsがまだ生成されていない場合は
         * 少し待って再確認する。
         */
        if (!props) {
            window.setTimeout(
                waitForDpoOptions,
                100
            );
            return;
        }

        /*
         * 初回のカード化
         */
        initCharamoaOptionImages();

        /*
         * DPOが#props内の選択肢を
         * 再生成した場合だけ監視する。
         */
        var observer =
            new MutationObserver(
                function (mutations) {
                    var needsUpdate = false;

                    mutations.forEach(
                        function (mutation) {
                            if (
                                mutation.type ===
                                'childList' &&
                                (
                                    mutation.addedNodes.length ||
                                    mutation.removedNodes.length
                                )
                            ) {
                                needsUpdate = true;
                            }
                        }
                    );

                    if (!needsUpdate) {
                        return;
                    }

                    /*
                     * DPOのDOM更新完了後に
                     * カード化する。
                     */
                    window.setTimeout(
                        function () {
                            initCharamoaOptionImages();
                        },
                        0
                    );
                }
            );

        observer.observe(
            props,
            {
                childList: true,
                subtree: true
            }
        );
    }


    /**
     * 先にCSVを読み込み、
     * 完了後にDPOを監視する。
     */
    initPriceTableValidation();

    loadOptionImages()
        .then(function () {
            if (
                document.readyState ===
                'loading'
            ) {
                document.addEventListener(
                    'DOMContentLoaded',
                    waitForDpoOptions
                );
            } else {
                waitForDpoOptions();
            }
        })
        .catch(function (error) {
            console.error(
                '[Charamoa Option Images]',
                error
            );
        });
})();